import { AccountSortOption } from '@rematter/frontend-lib-api-client';

import { ObjectRefRecord } from '~/shared/components/custom-attributes/types';
import { createQueryHook } from '~/shared/providers/api';

export const useCRMAccountsQuery = createQueryHook(
  'crm.accounts',
  (params: {
    searchTerm?: string;
    sorting?: AccountSortOption[];
    limit?: number;
    offset?: number;
  }) => ({
    accounts: {
      __args: {
        filter: params.searchTerm
          ? {
              searchTerm: params.searchTerm,
            }
          : undefined,
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 10,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        name: true,
      },
    },
  }),
  {
    select: (data): ObjectRefRecord[] =>
      data?.accounts.entries.map((account) => ({
        id: account.id,
        name: account.name,
      })) ?? [],
  },
);
